<script>
export default {
    name: "LocationSettings",
    data() {
        return {
            currencySymbol: window.systemCurrencySymbol,
            currencyName: window.systemCurrencyName,
            locationFormat: window.systemLocationFormat,
            systemTimezone: window.systemTimezone
        }
    },
    methods: {
        getCurrencySymbol() {
            return this.currencySymbol
        },
        getSystemTimezone() {
            return this.systemTimezone
        },
        formatCurrency(value) {
            const formatter = new Intl.NumberFormat(this.locationFormat, {
                style: 'currency',
                currency: this.currencyName,
            });
            return formatter.format(value)
        },
        formatPercent(value) {
            const formatter = new Intl.NumberFormat(this.locationFormat, {
                style: 'percent',
            });
            return formatter.format(value)
        }
    },
    mounted() {}
}
</script>

